import { User } from "firebase/auth";
import * as APITypes from "~/API";
import { firstOfCurrentMonth } from "./date";

export type Variable = {
  name: string;
  description: string;
}

const tenantFirstName: Variable = {
  name: "tenantFirstName",
  description: "The first name of the tenant.",
};

const tenantLastName: Variable = {
  name: "tenantLastName",
  description: "The last name of the tenant.",
};

const lastBillingPeriodEnd: Variable = {
  name: "lastBillingPeriodEnd",
  description: "The time when the last billing period ended for a tenant (i.e., when rent is due).",
};

const yourFullName: Variable = {
  name: "yourFullName",
  description: "Your full name.",
};

export const validVariables: Variable[] = [
  tenantFirstName,
  tenantLastName,
  lastBillingPeriodEnd,
  yourFullName,
];

export const replaceAllVariables = (message: string, user: User, tenant: APITypes.Tenant, lease: APITypes.Lease) => {
  message = message.replaceAll(`[${tenantFirstName.name}]`, tenant.firstName);
  message = message.replaceAll(`[${tenantLastName.name}]`, tenant.lastName);
  message = message.replaceAll(`[${lastBillingPeriodEnd.name}]`, firstOfCurrentMonth());
  message = message.replaceAll(`[${yourFullName.name}]`, user.displayName ?? "");
  if (message.includes("[") || message.includes("]")) {
    throw new Error("found a square bracket but no valid variable name");
  }
};